<template>
  <sfs-form-modal
    :id="modalId"
    size="md"
    title="Import (Create or Update) Users"
    @on-hide="resetFormData"
  >
    <imports-form
      description="Create or update user accounts."
      @on-submit="createUserImport"
      @on-save="handleSave"
      @on-cancel="closeModal"
      :key="formKey"
    >
      <template #downloads>
        <b-row>
          <b-col cols="12">
            <sfs-download-button
              label="Download Template"
              filename="Users Template.xlsx"
              :file-provider="$importsAPI.getUsersTemplate"
            />
          </b-col>
        </b-row>
      </template>
    </imports-form>
  </sfs-form-modal>
</template>

<script>
import ImportsForm from './Form.vue';
import formModalMixin from '@/mixins/formModalMixin';

export default {
  name: 'UsersImportsAddModal',
  mixins: [formModalMixin],
  components: {
    ImportsForm,
  },
  data() {
    return {
      modalId: 'users-imports-add-modal',
    };
  },
  methods: {
    createUserImport(data, handleCreate) {
      handleCreate(this.$importsAPI.usersCreate(data));
    },
    handleSave(data) {
      if (this.$route.name != 'imports') {
        this.$router.push({ name: 'imports' });
      } else {
        this.closeModal();
      }
      this.$emit('on-save', data);
    },
  },
};
</script>
